import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { SITE } from "../../lib/site-data";

const NAV = [
  { id: "fleet", label: "Fleet" },
  { id: "about", label: "About" },
  { id: "requirements", label: "Requirements" },
  { id: "contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-40 transition-all ${
        scrolled
          ? "bg-[#F8F4ED]/90 backdrop-blur border-b border-[#E5DCC9]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-3 flex items-center justify-between gap-4">
        <a
          href="#top"
          data-testid="header-logo-link"
          className="flex items-center gap-3 group"
        >
          <img
            src={SITE.logoUrl}
            alt="Long Horn Trailer Rentals logo"
            className="w-12 h-12 rounded-full object-cover ring-2 ring-[#D4A24C]/60 group-hover:ring-[#8B2332] transition"
            data-testid="header-logo-img"
          />
          <div className="leading-tight hidden sm:block">
            <div className="font-display font-bold text-[#1F1B16] text-base">
              Long Horn
            </div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-[#8B2332] font-semibold">
              Trailer Rentals
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-7 text-sm font-medium text-[#3A332B]">
          {NAV.map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              data-testid={`nav-link-${n.id}`}
              className="hover:text-[#8B2332] transition relative after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 hover:after:w-full after:bg-[#D4A24C] after:transition-all"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={SITE.phoneHref}
            data-testid="header-call-btn"
            className="hidden sm:inline-flex items-center gap-2 text-sm font-semibold text-[#1F1B16] hover:text-[#8B2332] transition"
          >
            <Phone className="w-4 h-4" />
            {SITE.phone}
          </a>
          <a
            href={SITE.bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-book-btn"
            className="btn-brand inline-flex items-center justify-center px-4 py-2 rounded-full text-sm font-semibold"
          >
            Book Now
          </a>
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden ml-1 p-2 rounded-md text-[#1F1B16]"
            onClick={() => setOpen((v) => !v)}
            aria-label="Open menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          className="md:hidden bg-[#F8F4ED] border-t border-[#E5DCC9]"
          data-testid="mobile-menu"
        >
          <div className="px-5 py-3 flex flex-col gap-2">
            {NAV.map((n) => (
              <a
                key={n.id}
                href={`#${n.id}`}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${n.id}`}
                className="py-2 text-[#3A332B] font-medium hover:text-[#8B2332]"
              >
                {n.label}
              </a>
            ))}
            <a
              href={SITE.phoneHref}
              data-testid="mobile-call-btn"
              className="py-2 text-[#1F1B16] font-semibold flex items-center gap-2"
            >
              <Phone className="w-4 h-4" /> {SITE.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
